import { render } from "./SiakadNavbar.vue?vue&type=template&id=fd839c94"
import script from "./SiakadNavbar.vue?vue&type=script&lang=js"
export * from "./SiakadNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/widyaputra/Documents/ybpm/sch-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__